import formatGroupedValues from "../utils/formatGroupedValues";

export const RELIABILITY_SORT_OPTIONS = [
  { value: "reason", label: "Reason" },
  { value: "last_modified", label: "Last Modified" },
  { value: "scheduled_start", label: "Scheduled Start Date" },
];

export const RELIABILITY_REASON_OPTIONS = [
  { value: "all", label: "All" },
  { value: "MIA/No Show", label: "MIA/No Show" },
  { value: "Sick", label: "Sick" },
  { value: "Other", label: "Other" },
];

export const RELIABILITY_NOTICE_OPTIONS = [
  { value: "", label: "All" },
  { value: "less24", label: "Less than 24h" },
  { value: "more24", label: "More than 24h" },
];

export const RELIABILITY_AFFECTS_OPTIONS = [
  { value: "", label: "All" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const RELIABILITY_STATUS_OPTIONS = [
  { value: "Assigned", label: "Assigned" },
  { value: "Unassigned", label: "Unassigned" },
];

export const RELIABILITY_DEFAULT_FILTERS = {
  filterReason: "all",
  filterNoticePeriod: "",
  filterAffectsReliability: "yes",
  filterModifyDateFrom: "",
  filterModifyDateTo: "",
  filterShiftDateFrom: "",
  filterShiftDateTo: "",
  filterStatus: ["Unassigned"],
  sortBy: "last_modified",
  sortOrder: "desc",
};

function formatDateRangeFilter(from, to) {
  if (from && to) return `${from} - ${to}`;
  if (from) return `From ${from}`;
  if (to) return `To ${to}`;
  return "";
}

const noticePeriodLabel = (value) => {
  if (value === "less24") return "Less than 24h";
  if (value === "more24") return "More than 24h";
  return "";
};

export function buildPersonnelReliabilityFilterChips(filters) {
  const chips = [];
  const {
    filterReason,
    filterNoticePeriod,
    filterAffectsReliability,
    filterStatus = [],
    filterModifyDateFrom,
    filterModifyDateTo,
    filterShiftDateFrom,
    filterShiftDateTo,
  } = filters;

  if (filterReason && filterReason !== "all") {
    chips.push({
      id: "reason",
      key: "filterReason",
      fieldId: "reliability-reason",
      label: `Reason: ${filterReason}`,
    });
  }
  const noticeLabel = noticePeriodLabel(filterNoticePeriod);
  if (noticeLabel) {
    chips.push({
      id: "notice",
      key: "filterNoticePeriod",
      fieldId: "reliability-notice",
      label: `Notice Period: ${noticeLabel}`,
    });
  }
  if (filterAffectsReliability) {
    const affectsLabel =
      filterAffectsReliability === "yes"
        ? "Yes"
        : filterAffectsReliability === "no"
          ? "No"
          : filterAffectsReliability;
    chips.push({
      id: "affects",
      key: "filterAffectsReliability",
      fieldId: "reliability-affects",
      label: `Affects Reliability: ${affectsLabel}`,
    });
  }
  if (filterStatus.length > 0) {
    chips.push({
      id: "status",
      key: "filterStatus",
      fieldId: "reliability-status",
      label: `Status: ${formatGroupedValues(filterStatus, (v) => v, 3)}`,
    });
  }
  const modifyRange = formatDateRangeFilter(
    filterModifyDateFrom,
    filterModifyDateTo,
  );
  if (modifyRange) {
    chips.push({
      id: "modified",
      key: "modifyDate",
      fieldId: "reliability-modify-from",
      label: `Modify Date: ${modifyRange}`,
    });
  }
  const shiftRange = formatDateRangeFilter(
    filterShiftDateFrom,
    filterShiftDateTo,
  );
  if (shiftRange) {
    chips.push({
      id: "scheduled",
      key: "shiftDate",
      fieldId: "reliability-shift-from",
      label: `Scheduled Date: ${shiftRange}`,
    });
  }
  return chips;
}
